import TextField from "../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import {
  FeriasService
} from "../../../services/FeriasService";
import moment from "moment";
import {
  SnackBarModule
} from "../../../modules/SnackBarModule";
import {
  SolicitarFeriasService
} from "../../../services/SolicitarFeriasService";

import {
  date
} from "date-typescript-library";

import FeriasVantagem from "../ferias-premio/ferias-vantagem/FeriasVantagem.vue";
import { tipoPerfil, TiposFeriasEnum } from "../../../constants";


export default {
  name: "FeriasPremios",

  components: {
    TextField,
    PeriodoField,
    SelectField,
    FeriasVantagem
  },

  data: () => ({
    campos: 0,
    saldoFerias: 0,
    form: {},
    feriasVantagemDialog: false,
    role: false,

    responsavelOptions: [],
    responsavel: null,

    exercicios: [],

    loading: {
      field: false,
      btn: false
    }
  }),

  beforeMount() {
    this.role = this.$store.state.user.Perfis.indexOf(tipoPerfil['COMANDANTE']) != -1;
    this.initializeForm();
    this.pegarDiasRestantesDaParecela();
  },

  mounted() {
    this.getExercicioItems();
    this.getResponsavelItems();

  },

  methods: {
    async pegarDiasRestantesDaParecela(index, event) {
      this.form[index].subtitulo = "Por favor selecione um exercício";

      event != undefined ? this.form[index].exercicio = event : ""
      const formData = new FormData();

      formData.append('exercicio', this.form[index].exercicio);
      formData.append('id_tipo', TiposFeriasEnum.FERIAS_PREMIO);
      const response = await SolicitarFeriasService.pegarDiasRestantes(formData);
      if (response.exercicio != null) {
        this.form[index].subtitulo = `Você possui um saldo de ${response.dias} dia(s) para o ${response.exercicio}º quinquênio.`;
        this.saldoFerias = response.dias;
      }
      this.form[this.campos] = {}
      this.form.pop()
    },


    async getExercicioItems() {
      this.loading.field = true;
      this.exercicios = await FeriasService.getExerciciosFeriasPremio();
      this.loading.field = false;
    },

    async calculateDays(index) {

      if (this.form[index].dataInicio) {

        let result = new Date(this.form[index].dataInicio);
        let ms = result.getTime() + (this.form[index].numeroDias * 24 * 60 * 60 * 1000);

        this.form[index].dataFim = date('Y-m-d', ms);


        //Update no forms inteiro para pode atualizar os valores
        this.form[this.campos] = {}
        this.form.pop()

        return this.calcularTotalDiasRestantes();
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    calcularTotalDiasRestantes() {
      const diasRestantesPorExercicio = {};
      const totalDiasPermitidosPorExercicio = 90; // Ajustado para 90 dias por exercício
      let totalDiasRestantes = totalDiasPermitidosPorExercicio;

      for (const value of this.form) {
        const exercicio = value.exercicio;
        const numeroDias = parseInt(value.numeroDias);

        if (!diasRestantesPorExercicio[exercicio]) {
          diasRestantesPorExercicio[exercicio] = totalDiasPermitidosPorExercicio;
        }

        // Verifica se ainda há dias restantes no exercício
        diasRestantesPorExercicio[exercicio] -= numeroDias;
        if (diasRestantesPorExercicio[exercicio] < 0) {
          SnackBarModule(
            "Número de dias dos períodos solicitados juntos deve ser menor ou igual a 90 por exercício",
            "error"
          );
          return true;
        }

        // Verifica o total de dias restantes no exercício
        totalDiasRestantes -= numeroDias;
        if (totalDiasRestantes < 0) {
          SnackBarModule(
            "Número de dias dos períodos solicitados juntos deve ser menor ou igual a 90 no total",
            "error"
          );
          return true;
        }
      }

      return false;
    },




    async getResponsavelItems() {
      this.loading.field = true;
      const response = await FeriasService.getMilitaresResponsavel();
      this.responsavelOptions = response.map(el => {
        return {
          text: el.nome,
          value: el.id,
        }
      });
      this.responsavelOptions?.unshift({ text: "Selecione", value: "" })
      this.loading.field = false;
    },

    verificarSeTodasDatasIniciasSaoMenoresQueUltimaDataFinal() {
      if (this.campos > 1) {
        this.form.forEach((value) => {
          if (this.form[this.campos - 1].dataInicio < value.dataFim) {
            return SnackBarModule("A data início deverá ser maior que a data final da última parcela", "error");
          }
        })
      }
      return;
    },

    prepareForm() {
      const formData = new FormData();
      let form = true;
      this.form.forEach((element, index) => {

        if (element.dataInicio == null || element.dataFim == null || element.exercicio == "" || element.numeroDias == "") {
          form = false
          SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");

        }

        if (element.numeroDias == 0) {
          form = false
          SnackBarModule("O número de dias deve ser maior que zero", "error");

        }

        if (this.role) {
          if (!this.responsavel) {
            form = false
            SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
          }
        }

        formData.append(`ferias[${index}][data_ini]`, moment(element.dataInicio).format("YYYY-MM-DD"))
        formData.append(`ferias[${index}][data_fin]`, moment(element.dataFim).format("YYYY-MM-DD"))
        formData.append(`ferias[${index}][exercicio]`, element.exercicio)
        formData.append(`ferias[${index}][id_tipo]`, 4)
        formData.append(`ferias[${index}][dias]`, element.numeroDias)


      });

      formData.append(`id_responsavel_ferias`, this.responsavel)



      if (form) {
        this.sendForm(formData);
        return;
      }

    },

    createNewForm() {
      this.campos = this.campos + 1
      this.form[this.campos - 1] = {
        subtitulo: "Por favor selecione uma parcela",
        exercicio: "",
        dataInicio: null,
        dataFim: null,
        numeroDias: ""
      }
    },


    removePeriodoFerias() {
      this.diasLimite = this.diasLimite + parseInt(this.form[this.campos - 1].numeroDias)
      this.form.pop()
      this.campos = this.campos - 1

    },

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await SolicitarFeriasService.postFeriasPremio(formData);
      this.loading.btn = false;
      if (response) {
        this.initializeForm();
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

    initializeForm() {
      this.campos = 1
      this.form = [{
        exercicio: "",
        dataInicio: null,
        dataFim: null,
        numeroDias: ""
      }]
    },

    close() {
      this.$emit("on-close");
    },
  }
};